import React, {useState, useCallback, useEffect} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors, validateEmail, roleTechnicalSpecialist} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {clientEditAction} from "../../../actions/clientAction";
import {Loader} from "../../../utils/loader/Loader";
import {InputProfile} from "../../../utils/input/InputProfile";

export function ClientEditModal({client, trigger, handleComplete, user, isEditTelegramId, isEditMaxUserId, isEditVKUserId}) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const handleChangeForm = useCallback((e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
  }, []);

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    let errs = {};
    if (form.first_name.trim() === '') {
      errs.first_name = true;
    }
    if (form.email !== '' && !validateEmail(form.email)) {
      errs.email = true;
    }
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }
    setLoading(true);

    form.telegram_id = form.telegram_id*1
    form.max_user_id = form.max_user_id*1
    form.vk_user_id = form.vk_user_id*1
    form.vk_peer_id = form.vk_peer_id*1

    dispatch(clientEditAction(form)).then((data) => {
      setLoading(false);
      setOpen(false);
      if (data.course) {
        form.course = data.course;
      }
      handleComplete(form);
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  useEffect(() => {
    if (open) {
      setForm({
        id: client.id,
        last_name: client.last_name,
        first_name: client.first_name,
        patronymic_name: client.patronymic_name,
        phone: client.phone,
        email: client.email,
        telegram_id: client.telegram_id,
        max_user_id: client.max_user_id,
        vk_user_id: client.vk_user_id,
        vk_peer_id: client.vk_peer_id
      });
      setErrors({});
    }
  }, [open, client]);

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={false}>
    <React.Fragment>
      <div className="modal__title modal__title--mb">Изменение {isEditTelegramId ? "ID телеграм":"данных клиента"}</div>
      {!form && <Loader size="large" padded={true}/>}
      {form && <React.Fragment>
        <div className="modal__scroll">
          <div className="modal__wrap">
            {!isEditTelegramId && !isEditMaxUserId && !isEditVKUserId && <InputProfile type="text"
                          title="Фамилия"
                          name="last_name"
                          placeholder="Введите фамилию"
                          value={form.last_name.trim()}
                          error={errors.last_name || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>}

            {!isEditTelegramId && !isEditMaxUserId && !isEditVKUserId && <InputProfile type="text"
                          title="Имя"
                          name="first_name"
                          placeholder="Введите имя"
                          value={form.first_name.trim()}
                          error={errors.first_name || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>}

            {!isEditTelegramId && !isEditMaxUserId && !isEditVKUserId && <InputProfile type="text"
                          title="Отчество"
                          name="patronymic_name"
                          placeholder="Введите отчество"
                          value={form.patronymic_name.trim()}
                          error={errors.patronymic_name || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>}

            {!isEditTelegramId && !isEditMaxUserId && !isEditVKUserId && <InputProfile type="email"
                          title="Эл. почта"
                          name="email"
                          placeholder="Введите эл. почту"
                          value={form.email}
                          error={errors.email || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>}

            {!isEditTelegramId && !isEditMaxUserId && !isEditVKUserId && <InputProfile type="text"
                          title="Телефон"
                          name="phone"
                          placeholder="Введите телефон"
                          value={form.phone}
                          error={errors.phone || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>}
                          
            {user && user.role_id === roleTechnicalSpecialist && isEditTelegramId && !isEditMaxUserId && !isEditVKUserId && <InputProfile type="text"
                          title="Ид телеграмм"
                          name="telegram_id"
                          placeholder=""
                          value={form.telegram_id}
                          error={errors.telegram_id || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>}

            {user && user.role_id === roleTechnicalSpecialist && isEditMaxUserId && !isEditTelegramId && !isEditVKUserId && <InputProfile type="text"
                          title="Ид Макс"
                          name="max_user_id"
                          placeholder=""
                          value={form.max_user_id}
                          error={errors.max_user_id || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>}

            {user && user.role_id === roleTechnicalSpecialist && isEditVKUserId && !isEditTelegramId && !isEditMaxUserId && <InputProfile type="text"
                          title="VK user ID"
                          name="vk_user_id"
                          placeholder=""
                          value={form.vk_user_id}
                          error={errors.vk_user_id || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>}

            {user && user.role_id === roleTechnicalSpecialist && isEditVKUserId && !isEditTelegramId && !isEditMaxUserId && <InputProfile type="text"
                          title="VK peer ID"
                          name="vk_peer_id"
                          placeholder=""
                          value={form.vk_peer_id}
                          error={errors.vk_peer_id || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>}
          </div>
        </div>
        <div className="modal__btns">
          <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Сохранить</button>
        </div>
      </React.Fragment>}
    </React.Fragment>
  </Modal>
};
